import { render } from "./BaseInvoice.vue?vue&type=template&id=c62767a8&scoped=true"
import script from "./BaseInvoice.vue?vue&type=script&lang=js"
export * from "./BaseInvoice.vue?vue&type=script&lang=js"

import "./BaseInvoice.vue?vue&type=style&index=0&id=c62767a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62767a8"]])

export default __exports__